export default __webpack_public_path__ + "static/fall1 (3)-17b7c4185ab3377f01c86948c9c27798.jpeg";